import React, { PureComponent, Fragment } from 'react';
import Waypoint from 'react-waypoint';

export default class TextWave extends PureComponent {

  constructor() {
    super();
    this.title = React.createRef();
  }

  componentDidMount() {
    const splitTarget = this.title.current.children;

    this.titleText = new SplitText(splitTarget, { type: 'lines, words, chars' });

    this.titleTl = new TimelineMax({
      paused: true,
      onComplete: this.resetText,
    });

    this.titleTl
      .set(this.titleText.words, { whiteSpace: 'nowrap' })
      .set(this.titleText.lines, { whiteSpace: 'nowrap' })
      .staggerFrom(this.titleText.chars, 0.69, { y: 15, scale: 0.95, opacity: 0, transformOrigin: '50% 100%', stagger: { from: 'center', amount: 0.22 }, ease: Back.easeOut.config(4) });
  }

  animateTitle = () => {
    this.titleTl.play();
  }

  resetText = () => {
    this.titleText.revert();
  }

  componentWillUnmount() {
    this.titleTl.kill();
  }

  render() {
    return (
      <Fragment>
        <Waypoint
          onEnter={this.animateTitle}
          bottomOffset={150}
        />
        <span ref={this.title} style={{ fontKerning: 'none' }}>
          {this.props.children}
        </span>
      </Fragment>
    );
  }
}
